var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.95352 7.70167L3.65524 6.74719L1.74628 7.34374L2.04456 8.29822L2.3075 9.13962C2.64759 10.2279 3.14311 11.2354 3.76504 12.1408L3.34386 12.3839L1.1788 13.6339L0.312777 14.1339L1.31278 15.866L2.1788 15.366L4.34386 14.116L5.0609 13.702C5.70893 14.3525 6.43424 14.9207 7.21939 15.3938L7.06283 15.665L5.81283 17.8301L5.31283 18.6961L7.04488 19.6961L7.54488 18.8301L8.79488 16.665L9.02234 16.271C9.86806 16.5924 10.759 16.8135 11.6788 16.9223V17.4999V19.9999V20.9999H13.6788V19.9999V17.4999V16.9999H13.999V16.9555C14.9903 16.8671 15.9508 16.6484 16.8603 16.3142L17.0628 16.665L18.3128 18.8301L18.8128 19.6961L20.5449 18.6961L20.0449 17.8301L18.7949 15.665L18.6742 15.456C19.4534 14.9979 20.1752 14.4468 20.8228 13.8151L21.3439 14.116L23.509 15.366L24.375 15.866L25.375 14.1339L24.509 13.6339L22.3439 12.3839L22.144 12.2685C22.8078 11.3305 23.3344 10.2794 23.6906 9.13962L23.9535 8.29822L24.2518 7.34374L22.3428 6.74719L22.0445 7.70167L21.7816 8.54307C20.5812 12.3844 17.0236 14.9999 12.999 14.9999C8.97447 14.9999 5.41688 12.3844 4.21646 8.54307L3.95352 7.70167Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClosed);
export default __webpack_public_path__ + "static/media/eye-closed.d3c1190e66f907df7bded21cc1e089b9.svg";
export { ForwardRef as ReactComponent };